import axios from "axios";
import { create } from "zustand";
import { GetUserAccessToken } from "../../utils/helper";
import ApiBaseURL from "../../utils/config";
import ApiList from "../../utils/apiList";
const eLoanStore = create((set) => ({
  KYCoveralDetails: [],
  allPolicyList: [],

  post_verifyPolicy: async (data) => {
    try {
      const response = await ApiBaseURL.post('/Loan/VerifyPolicy', data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      return response.data
    } catch (error) {
      console.error('Error:', error)
    }
  },

  post_getEloanDetails: async (data) => {
    try {
      const response = await ApiBaseURL.post("/Loan/GetEloanDetails",
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  },

  post_generateOTP: async (data) => {
    try {
      const response = await ApiBaseURL.post(
        "/Loan/GenerateOTP",
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  },

  post_saveEloanProposal: async (data) => {
    try {
      const response = await ApiBaseURL.post(
        "/Loan/SaveEloanProposal",
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  },

  delete_deleteEloan: async (data) => {
    try {
      const response = await ApiBaseURL.post(
        "/Loan/DeleteEloan",
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  },

  getPolicyListByUserId: async (data) => {
    try {
      const response = await ApiBaseURL.post(
        "/Loan/GetPolicyListByUserId",
        data,
        {
          headers: {
            Authorization: "Bearer " + GetUserAccessToken(),
            "Access-Control-Allow-Origin": "*",
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );
      if (response.data.code === "100") {
        set({ allPolicyList: response.data.data });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  },
}));

export { eLoanStore };
